import manifestJson from "@shared/imageManifest.json";

export interface ImageVariants {
  id: string;
  width: number;
  height: number;
  widths: number[];
  avif: boolean;
}

const manifest: Record<string, ImageVariants> = manifestJson;

export function imageVariants(src: string): ImageVariants | undefined {
  // Local catalogue only. Uploads, blob URLs and third-party images pass through.
  const local = src.replace(/^https:\/\/nordiskauterum\.se(?=\/)/, "");
  return manifest[local];
}

export function imageUrl(
  image: ImageVariants,
  width: number,
  format: "webp" | "avif" = "webp"
) {
  return `/images/optimized/${image.id}-${width}.${format}`;
}

export function imageSrcSet(
  image: ImageVariants,
  format: "webp" | "avif" = "webp"
) {
  return image.widths
    .map(width => `${imageUrl(image, width, format)} ${width}w`)
    .join(", ");
}

export function optimizedImageSrc(src: string, targetWidth = 960) {
  const image = imageVariants(src);
  if (!image) return src;
  const width =
    image.widths.find(width => width >= targetWidth) ?? image.widths.at(-1)!;
  return imageUrl(image, width);
}

/** object-cover scales to the slot's height as well as its width. */
export function coverImageSizes(src: string, slots: string, mobileVh: number, desktopVh: number) {
  const image = imageVariants(src);
  if (!image) return slots;
  const factor = image.width / image.height;
  const mobile = (mobileVh * factor).toFixed(2);
  const desktop = (desktopVh * factor).toFixed(2);
  const entries = slots.split(", ");
  const fallback = entries.pop()!;
  return [
    ...entries.map(entry => entry.replace(/^(\([^)]*\)\s+)(.+)$/, `$1max($2, ${desktop}vh)`)),
    `(min-width: 640px) max(${fallback}, ${desktop}vh)`,
    `max(${fallback}, ${mobile}vh)`,
  ].join(", ");
}
